import { Injectable } from '@angular/core';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class RouteTrackerService {
    constructor(
        private router: Router,
        private analytics: AngularFireAnalytics
    ) { }

    trackRouteChanges (): void {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                console.log('route-tracker.service.ts -> 17  ', event.urlAfterRedirects || event.url);
                const pagePath = event.urlAfterRedirects || event.url;
                this.analytics.logEvent('page_view', { page_path: pagePath });
            }
        });
    }
}
